import { jsx } from "react/jsx-runtime";
import { Skeleton } from "@nxt-costco-com/forge-components";
import { VIEW_NAME_SKELETON } from "./constants.js";
import { MAX_TILE_WIDTH } from "./styles.js";
const FeatureHighlightCardV2Skeleton = () => /* @__PURE__ */ jsx(
  Skeleton,
  {
    "data-testid": VIEW_NAME_SKELETON,
    height: 460,
    variant: "rectangular",
    width: MAX_TILE_WIDTH
  }
);
export {
  FeatureHighlightCardV2Skeleton
};
